import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import { Exercise, Lecture, NoTimeExercise, PianoScene, Section, StaffExercise, Tutorial } from "Utils/TutorialConfigHelper";
import timestamps from './level21.json';

const zero = '0:0';

const Level21 = Tutorial(21, zero, [
  Section([
    Lecture('D in the Bass Clef', zero),
    Lecture('D on the Keyboard', zero),
    Exercise('Find D', zero, PianoScene({
      objectives: [
        { target: 'D3', text: 'Play D on your keyboard' }
      ]
    }), [])
  ]),
  Section([
    Lecture('Shifting to D Position', zero),
    Exercise('D Position', zero, NoTimeExercise({ centre_align_horizontal: true, objectives: [{}, {}] }), []),
    Exercise('Playing in Time', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ]),
  Section([
    Lecture('Using Both Hands', zero),
    Exercise('Hands Together', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ]),
  Section([
    Lecture('Seven Notes in the Left Hand', zero),
    Exercise('Playing D to C', zero, NoTimeExercise({ centre_align_horizontal: true, objectives: [{}, {}] }), []),
    Lecture('Seven-Note Stretch', zero),
    Exercise('Playing in Time', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ]),
  Section([
    Lecture('Using Both Hands', zero),
    Exercise('Alternating Hands', zero, StaffExercise({ objectives: [{}] }), []),
    Exercise('Hands Together', zero, StaffExercise({ objectives: [{}, {}] }), []),
  ])
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level21);
//export default Level21;
